import { truncate } from '@/assets/styles/mixins/index.styles'
import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Container = styled('div')`
    display: flex;
    flex-direction: column;
    ${truncate}
`

export const MoreUsers = styled('div')<{ theme?: TTheme }>`
    background-color: ${({ theme }) => theme.colors.primary[50]};
    color: ${({ theme }) => theme.colors.primary[900]};
    padding: 2px 16px;
    border-radius: 20px;
    margin-top: 4px;
`
